export class PostagesConfig {
  configs: PostageConfig[];
  constructor(json: any) {
    this.configs = [];
    if (json.langs) {
      for (const entry of json.langs) {
        this.configs.push(new PostageConfig(entry));
      }
    }
  }
  getPostageConfig(lang: string): PostageConfig {
    if (!lang) {
      return null;
    }
    for (const c of this.configs) {
      if (c.lang.toUpperCase() === lang.toUpperCase()) {
        return c;
      }
    }
    return null;
  }
}
export class PostageConfig {
  lang: string;
  label: string;
  groups: Group[];
  notes: string[];
  constructor(json: any) {
    this.lang = json.name ? json.name : '';
    this.label = json.label ? json.label : '';
    this.groups = [];
    if (json.groups) {
      for (const entry of json.groups) {
        this.groups.push(new Group(entry));
      }
    }
    this.notes = [];
    if (json.notes) {
      for (const note of json.notes) {
        this.notes.push(note);
      }
    }
  }
  public getEnvelopes(postage: string): Envelope[] {
    for (const g of this.groups) {
      if (g.isSupported(postage)) {
        return g.envelopes;
      }
    }
    return [];
  }
}
export class Group {
  label: string;
  value: string;
  postages: Postage[];
  envelopes: Envelope[];
  constructor(json: any) {
    this.label = json.label ? json.label : '';
    this.value = json.value ? json.value : '';
    this.postages = [];
    this.envelopes = [];
    if (json.postages) {
      for (const entry of json.postages) {
        this.postages.push(new Postage(entry));
      }
    }
    if (json.envelopes) {
      for (const entry of json.envelopes) {
        this.envelopes.push(new Envelope(entry));
      }
    }
  }
  public isSupported(postage: string) {
    for (const p of this.postages) {
      if (p.value === postage) {
        return true;
      }
    }
    return false;
  }
}
export class Postage {
  label: string;
  value: string;
  encart: boolean;

  constructor(json: any) {
    this.label = json.label ? json.label : '';
    this.value = json.value ? json.value : '';
    this.encart = json.encart ? json.encart : false;
  }
}
export class Envelope {
  label: string;
  value: string;

  constructor(json: any) {
    this.label = json.label ? json.label : '';
    this.value = json.value ? json.value : '';
  }
}
export class Purge {
  treatmentChain: string;
  postage: string[];
  delay: number;

  constructor(json: any) {
    this.treatmentChain = json.treatmentChain ? json.treatmentChain : '';
    this.postage = json.postage ? json.postage : [];
    this.delay = json.delay ? json.delay : '';
  }
}
